import { OnyxMapRoutePointType } from '.';

export enum OnyxRouteLegType {
  VEHICLE = 'vehicle',
  FERRY = OnyxMapRoutePointType.FERRY,
  TRAIN = OnyxMapRoutePointType.TRAIN,
  TUNNEL = OnyxMapRoutePointType.TUNNEL,
}
